import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import InsightOverview from './InsightOverview'
import AverageMetricDeepDive from './AverageMetricDeepDive'

interface Props {
    cardDetails?: any
    selectedGroup: string | null
    kpi_literal: string | null
    kpi_value: string | null
    kpi_unit: string | null
    selectedDateRange: any[]
    selectedOption?: string | null
    toDownloadAsReport?: boolean
    reportError?: (x: boolean) => void
}
const InsightsDeepDiveSection: React.FC<Props> = ({ cardDetails, selectedGroup, kpi_literal, kpi_value, kpi_unit, selectedDateRange, selectedOption, toDownloadAsReport = true, reportError }) => {
    const { t } = useTranslation()
    const [show, setShow] = useState(false)

    useEffect(() => {
        setShow(toDownloadAsReport)
    }, [toDownloadAsReport])

    return (
        <div className="grid grid-cols-3gap-3 my-4" aria-label={t('Insights Deep Dive')}>
            {/* <button type="button" onClick={(e) => setShow(!show)} className="flex w-full justify-between flex-row col-span-3 rounded-[0.45rem] shadow-1 py-2 px-2 cursor-pointer">
                <div className="text-sm font-medium  h-fit">{t('Insights Deep Dive')}</div>
                <Icon name={show ? 'up' : 'down'} size={1.5}></Icon>
            </button> */}

            {show ? (
                <div className="w-full col-span-3 px-0 py-2">
                    <InsightOverview
                        cardDetails={cardDetails}
                        selectedGroup={selectedGroup}
                        kpi_literal={kpi_literal}
                        kpi_value={kpi_value}
                        kpi_unit={kpi_unit}
                        selectedDateRange={selectedDateRange}
                        selectedOptionConfig={selectedOption}
                        toDownloadAsReport={toDownloadAsReport}
                        reportError={reportError}
                    />
                    <AverageMetricDeepDive selectedGroup={selectedGroup} selectedKPI={kpi_value ?? null} selectedDateRange={selectedDateRange} selectedOptionConfig={selectedOption} toDownloadAsReport={toDownloadAsReport} reportError={reportError} />
                </div>
            ) : null}
        </div>
    )
}
export default InsightsDeepDiveSection
